export const isProd = import.meta.env.PROD;
export const isDev = !isProd;
export const URL = isDev ? 'http://localhost:3001' : 'https://api.secre.tary.ai/v1';
export const API_URL = `${URL}/v1`;
export const ASSET_URL = `${URL}/public`;
export const API_CHAT_URL = `${URL}/v1/janet/chat`;
export const API_LEAD_GEN_URL = `${URL}/v1/janet/lead`;
export const SESSION_KEY = 'secre.tary.ai:janet';
export const TEST_KEY = 'secre.tary.ai:test';